module.exports = __webpack_public_path__ + "img/kuang.8495eaf9.png";